import React, {useEffect, useRef, useState} from 'react';
import brokenImage from '../../../images/broken_image.png';
import {FLOW} from '../../../pages/RandomSampler/Config/RandomSampler.constants';

const useImageUrl = (url, getIsClicked, isCleanClick, setOpen, setCurrentImageIndex, setNotificationOpen, isApproved, flow) => {
    const imageRef = useRef<Element | any>(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const onClick = () => {
        setIsClicked(!isClicked);
        getIsClicked && getIsClicked(true);
    };

    /***
     * handleEyeClick - update the image index with the current index
     * and the open param to true and
     * @param index - index of the current image
     */
    const handleEyeClick = (index) => {
        setOpen(true);
        setCurrentImageIndex(index);
    };

    const handleCloseNotification = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotificationOpen(false);
    };

    useEffect(() => {
        !url && setIsLoaded(false);
        if (imageRef.current) {
            const image = new Image();

            image.src = url;
            image.onload = () => {
                if (imageRef.current) {
                    imageRef.current.src = image.src;
                    imageRef.current.onload = () => setIsLoaded(true);
                }
            };

            image.onerror = () => {
                if (imageRef.current && url) {
                    imageRef.current.src = brokenImage;
                    setIsLoaded(true);
                }
            };

        }
    }, [imageRef.current, url]);

    useEffect(() => {
        isCleanClick && setIsClicked(false);
    }, [isCleanClick]);


    useEffect(() => {
        if (flow === FLOW.autoClasses && isApproved !== isClicked) {
            setIsClicked(!isClicked);
        }
    }, [isApproved]);


    return {imageRef, isLoaded, onClick, isClicked, handleEyeClick, handleCloseNotification};
};

export default useImageUrl;
